import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workRequestId'}/edit`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workRequestId/edit`;

export const URL = (workRequestId: number): RouteDefinition => `${baseRoute}/${workRequestId}/edit`;
